var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2942 3.34564C11.2236 3.49017 9.86423 4.61162 9.55615 6.42956C9.51103 6.69579 9.50708 6.83931 9.50708 8.21431V9.59613H8.42017H7.33325V11.081V12.5659L8.41675 12.5694L9.50024 12.5728L9.50359 16.6345L9.50694 20.6961H11.0827H12.6584L12.6619 16.6311L12.6653 12.5661H14.1955H15.7256L15.7334 12.4813C15.7436 12.3707 15.8649 9.77583 15.8647 9.67411L15.8645 9.59613H14.2639H12.6634L12.6694 8.37222C12.6745 7.33452 12.6787 7.12974 12.6971 7.02626C12.7728 6.60001 12.9496 6.38962 13.322 6.28259C13.5268 6.22377 13.6234 6.21944 14.7317 6.2194L15.7795 6.21936L15.7877 6.08713C15.7996 5.89412 15.8572 3.45466 15.8501 3.4476C15.8429 3.44056 15.3019 3.39126 15.0168 3.37167C14.4686 3.33398 13.6405 3.32148 13.2942 3.34564Z",
    fill: "#6B7280"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.3196c4c4.svg";
export { ForwardRef as ReactComponent };